'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _mediator = require('../../components/mediator');

var _mediator2 = _interopRequireDefault(_mediator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HLSEvents = function () {
  function HLSEvents(instanceId) {
    (0, _classCallCheck3.default)(this, HLSEvents);

    this.instanceId = instanceId;
  }

  (0, _createClass3.default)(HLSEvents, [{
    key: 'ready',
    value: function ready() {
      _mediator2.default.trigger(this.instanceId + ':flashready');
    }
  }, {
    key: 'videoSize',
    value: function videoSize(width, height) {
      _mediator2.default.trigger(this.instanceId + ':videosizechanged', width, height);
    }
  }, {
    key: 'complete',
    value: function complete() {
      _mediator2.default.trigger(this.instanceId + ':complete');
    }
  }, {
    key: 'error',
    value: function error(code, url, message) {
      _mediator2.default.trigger(this.instanceId + ':error', code, url, message);
    }
  }, {
    key: 'manifest',
    value: function manifest(duration, loadmetrics) {
      _mediator2.default.trigger(this.instanceId + ':manifestloaded', duration, loadmetrics);
    }
  }, {
    key: 'audioLevelLoaded',
    value: function audioLevelLoaded(loadmetrics) {
      _mediator2.default.trigger(this.instanceId + ':audiolevelloaded', loadmetrics);
    }
  }, {
    key: 'levelLoaded',
    value: function levelLoaded(loadmetrics) {
      _mediator2.default.trigger(this.instanceId + ':levelloaded', loadmetrics);
    }
  }, {
    key: 'levelEndlist',
    value: function levelEndlist(level) {
      _mediator2.default.trigger(this.instanceId + ':levelendlist', level);
    }
  }, {
    key: 'fragmentLoaded',
    value: function fragmentLoaded(loadmetrics) {
      _mediator2.default.trigger(this.instanceId + ':fragmentloaded', loadmetrics);
    }
  }, {
    key: 'fragmentPlaying',
    value: function fragmentPlaying(playmetrics) {
      _mediator2.default.trigger(this.instanceId + ':fragmentplaying', playmetrics);
    }
  }, {
    key: 'position',
    value: function position(timemetrics) {
      _mediator2.default.trigger(this.instanceId + ':timeupdate', timemetrics);
    }
  }, {
    key: 'state',
    value: function state(newState) {
      _mediator2.default.trigger(this.instanceId + ':playbackstate', newState);
    }
  }, {
    key: 'seekState',
    value: function seekState(newState) {
      _mediator2.default.trigger(this.instanceId + ':seekstate', newState);
    }
  }, {
    key: 'switch',
    value: function _switch(newLevel) {
      _mediator2.default.trigger(this.instanceId + ':levelchanged', newLevel);
    }
  }, {
    key: 'audioTracksListChange',
    value: function audioTracksListChange(trackList) {
      _mediator2.default.trigger(this.instanceId + ':audiotracklistchanged', trackList);
    }
  }, {
    key: 'audioTrackChange',
    value: function audioTrackChange(trackId) {
      _mediator2.default.trigger(this.instanceId + ':audiotrackchanged', trackId);
    }
  }]);
  return HLSEvents;
}();

exports.default = HLSEvents;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/clappr/src/playbacks/flashls/flashls_events.js
// module id = 263
// module chunks = 0